import React, { useState, useEffect } from "react"
import { listAllOrganizations } from "../../../utils/orgHelpers"
import OrganizationDetail from "./OrganizationDetail"

const OrganizationsPanel = ({ initialOrgId, onConsumeInitialOrgId }) => {
  const [organizations, setOrganizations] = useState([])
  const [loading, setLoading] = useState(true)
  const [selectedOrgId, setSelectedOrgId] = useState(initialOrgId || null)

  useEffect(() => {
    const load = async () => {
      const { organizations: orgs } = await listAllOrganizations()
      setOrganizations(orgs || [])
      setLoading(false)
    }
    load()
  }, [])

  useEffect(() => {
    if (initialOrgId) {
      setSelectedOrgId(initialOrgId)
      onConsumeInitialOrgId?.()
    }
  }, [initialOrgId])

  if (selectedOrgId) {
    return <OrganizationDetail orgId={selectedOrgId} onBack={() => setSelectedOrgId(null)} />
  }

  if (loading) {
    return <div className="p-6 text-center text-muted-foreground text-sm">Loading organizations...</div>
  }

  return (
    <div className="bg-card border border-border rounded-xl overflow-hidden">
      <div className="px-4 py-3 border-b border-border flex items-center justify-between">
        <h2 className="font-semibold text-foreground">All Organizations</h2>
        <span className="text-sm text-muted-foreground">{organizations?.length || 0} total</span>
      </div>

      {organizations?.length === 0 ? (
        <div className="p-6 text-center text-muted-foreground text-sm">No organizations yet.</div>
      ) : (
        <div className="divide-y divide-border">
          {organizations?.map((org) => (
            <button
              key={org?.orgId}
              onClick={() => setSelectedOrgId(org?.orgId)}
              className="w-full flex items-center gap-3 px-4 py-3 hover:bg-muted/50 transition-colors text-left"
            >
              {org?.logoUrl ? (
                <img src={org.logoUrl} alt={org?.name} className="size-8 rounded object-cover shrink-0" />
              ) : (
                <div className="size-8 rounded bg-muted shrink-0" />
              )}
              <div className="min-w-0 flex-1">
                <p className="text-sm font-medium text-foreground truncate">{org?.name || "Unnamed"}</p>
                <p className="text-xs text-muted-foreground truncate">{org?.orgType || "—"}</p>
              </div>
              <span className={`text-xs px-2 py-0.5 rounded-full shrink-0 ${
                org?.status === "suspended"
                  ? "bg-destructive/10 text-destructive"
                  : "bg-success/10 text-success"
              }`}>
                {org?.status === "suspended" ? "Suspended" : "Active"}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  )
}

export default OrganizationsPanel